import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./loading.css";

function MoviesDetails({ movies, setMovies }) {
  let { id } = useParams();
  const [movieDetail, setMovieDetail] = useState({});

  useEffect(() => {
    const getMovies = async () => {
      const response = await axios.get(
        `https://api.themoviedb.org/3/movie/${id}?api_key=c5f2c84d63771bd8924b941706200ac1&language=en-US`
      );
      setMovieDetail(response.data);
    };
    getMovies();
    // eslint-disable-next-line
  }, []);

  return movieDetail.poster_path ? (
    <div>
      <h1 className="text-center mt-4">{movieDetail.title}</h1>
      <ul class="list-unstyled p-4">
        {movieDetail.overview ? (
          <li className="mt-2">
            <h4>Description: {movieDetail.overview}</h4>
          </li>
        ) : (
          <li className="mt-2">
            <h4>Description: No Description.</h4>
          </li>
        )}
        {movieDetail.release_date ? (
          <li className="mt-4">
            <h4>Year: {movieDetail.release_date}</h4>
          </li>
        ) : (
          <li className="mt-4">
            <h4>Year: Unspecified.</h4>
          </li>
        )}
      </ul>
      <div className="d-flex justify-content-center">
        <img
          className="rounded"
          src={`https://image.tmdb.org/t/p/w400/${movieDetail.poster_path}`}
          alt=""
          style={{
            boxShadow: "black 40px 40px 40px",
          }}
        />
      </div>
      <Link className="btn btn-outline-light btn-lg m-4" to="/">
        Go Back
      </Link>
    </div>
  ) : (
    <div className="d-flex justify-content-center align-item-center">
      <div className="loading">Loading&#8230;</div>
    </div>
  );
}
export default MoviesDetails;
